import { xAxis, yAxis } from '~/core/axis/axis';
import { drawXAxis } from '~/core/axis/x-axis/drawXAxis';
import { drawYAxis } from '~/core/axis/y-axis/drawYAxis';
import { drawBars } from '~/core/series/bars/bars';
import { drawCandles } from '~/core/series/candles/candles';
import { drawLine } from '~/core/series/line/line';
import { Domain, PriceRange } from '~/types/axis.types';
import {
  ChartAPIFunctionProps,
  CreateChartOptionsWithColors,
  XAxis,
} from '~/types/create.types';
import { TsDataPoint } from '~/types/timeseries.types';
import { clearChart } from '~/utils/clearChart';
import {
  getVisibleRange,
  rangeIndexesToYCoordinate,
} from '~/utils/visibleRange';

export const recalculateScaleVisibleRange = (
  options: CreateChartOptionsWithColors,
  data: TsDataPoint[],
  x: XAxis,
  barSpacing: number
) => {
  const visibleRange = getVisibleRange({ options, x, barSpacing });
  const updatedDataRange = rangeIndexesToYCoordinate({
    data,
    startIndex: visibleRange[0],
    endIndex: visibleRange[1],
  });
  return recalculateScale({
    options,
    data,
    domain: visibleRange,
    barSpacing,
    dataRange: updatedDataRange,
  });
};

interface RecalculateScaleProps {
  options: CreateChartOptionsWithColors;
  data: TsDataPoint[];
  domain: Domain;
  barSpacing?: number;
  dataRange?: PriceRange;
}

export const recalculateScale = ({
  options,
  data,
  domain,
  barSpacing,
  dataRange,
}: RecalculateScaleProps) => {
  const x = xAxis({
    options,
    data,
    domain,
    barSpacing,
  });
  const y = yAxis({
    options,
    data,
    dataRange,
  });

  return { x, y };
};

const mapSeriesTypeToDrawFn = {
  line: drawLine,
  bars: drawBars,
  candlestick: drawCandles,
};

export const reDraw = (base: ChartAPIFunctionProps) => {
  // TODO handle map bars function for chart and bars functionality

  clearChart(base.context, base.options);
  drawXAxis(base);
  drawYAxis(base);
  mapSeriesTypeToDrawFn[base.seriesType](base);
};
